
export default {
  ourMediaPartner: "شريكنا الإعلامي",
  ourMediaPartners: "شركاؤنا",
  collaborationText: "تعاون",
  toProvideText: "لتوفير",
  partnerDescription: "نتعاون مع شركاء إعلاميين رائدين لتقديم حلول إعلانية شاملة",
  viewBusinessCases: "عرض حالات الأعمال",
  viewMediaKit: "عرض الحقيبة الإعلامية",
  readyToReach: "هل أنت مستعد للوصول إلى جمهورك؟",
  startYourDigital: "ابدأ حملتك الرقمية اليوم",
  andReachYour: "والوصول إلى جمهورك المستهدف",
  createCampaign: "إنشاء حملة",
  learnMore: "معرفة المزيد",
  
  // Hero Section
  premiumMediaPartnerNetwork: "شبكة شركاء إعلاميين متميزة",
  
  // Stats Section
  ourNetworkImpact: "تأثير شبكتنا",
  connectingBrands: "ربط العلامات التجارية بالجماهير من خلال شبكة شركائنا الواسعة",
  mediaPartners: "شركاء إعلاميون",
  digitalScreens: "شاشات رقمية",
  
  // Partners Section
  exploreOurPartners: "استكشف شركاءنا",
  explorePartnersDesc: "اختر من شبكات الإعلان الداخلية والخارجية للوصول إلى جمهورك المستهدف",
  indoor: "داخلي",
  outdoor: "خارجي",
  comingSoon: "قريباً",
  stayTuned: "ابق متابعاً",
  
  // Benefits Section
  whyChoosePartners: "لماذا تختار شركاءنا الإعلاميين؟",
  whyChoosePartnersDesc: "اطلق قوة الشراكات الاستراتيجية لأقصى تأثير إعلاني",
  targetedAudience: "جمهور مستهدف",
  targetedAudienceDesc: "اوصل لعملائك المثاليين حيث يقضون وقتهم مع استهداف دقيق.",
  performanceMetrics: "مقاييس الأداء",
  performanceMetricsDesc: "تتبع الانطباعات والمشاركة وعائد الاستثمار مع تحليلات وتقارير مفصلة.",
  quickSetup: "إعداد سريع",
  quickSetupDesc: "أطلق الحملات بسرعة مع عملية الإنشاء المبسطة وسير عمل الموافقة.",
  
  // Partner Descriptions
  tableadsDesc: "اوصل لجمهورك أينما يأكلون ويشربون ويسترخون — في المقاهي والمطاعم والصالات.",
  alanDesc: "أعلن حيث يتحرك الناس ويلتقون ويلعبون - مراكز اللياقة البدنية والمقاهي والصالات ومناطق الألعاب.",
  wakiDesc: "تواصل مع الجيل القادم - الإعلان الرقمي في المدارس الخاصة العالمية.",
  attentionDesc: "الهدف من Attention هو تشغيل إعلام خارجي احترافي عالمي المستوى. الهدف هو أن نكون استثنائيين بالمعايير العالمية، وليس فقط معايير دول الخليج أو السعودية.",
  comingSoonDesc: "شراكات إعلامية خارجية مثيرة في الأفق. ابق متابعاً للحصول على حلول إعلانية مبتكرة ستوسع نطاق وصولك.",
  elevateMediaDesc: "استقطب الجمهور في كل طابق — Elevate Media تقدم حلول إعلانية متميزة داخل المصاعد في المباني السكنية والتجارية.",
  onspotDesc: "تواصل مع جمهورك أثناء الانتظار — On Spot تقدم إعلانات رقمية في صالونات الحلاقة للرجال وصالونات التجميل للنساء.",
  
  // Partner Detail Page
  partnerDetailsComingSoon: "تفاصيل الشريك قريباً",
  workingOnAddingInfo: "نحن نعمل على إضافة المزيد من المعلومات حول هذا الشريك.",
  backToPartners: "العودة إلى الشركاء",
} as const;
